import useUser from "../store/user";
import { clearLocalStorage } from "./local-storage";
import { closeSocketConnection } from "./socket";

export const logout = async () => {
  console.log("Logging out...");
  const { setUser, setLoading } = useUser.getState();
  clearLocalStorage();
  closeSocketConnection();
  setUser(null);
  setLoading(false);
};
